import type { GetFolderAssetsQuery } from '../gql/generated/GetFolderAssets';

type FolderAssetResult = Extract<
  NonNullable<NonNullable<GetFolderAssetsQuery['account']>['asset']>,
  { __typename: 'FolderAsset' }
>;

export type FolderAssetsConnection = NonNullable<FolderAssetResult['assets']>;

export const getFolderAssetsConnection = (
  data: GetFolderAssetsQuery | undefined
): FolderAssetsConnection | undefined =>
  data?.account?.asset?.__typename === 'FolderAsset'
    ? data.account.asset.assets ?? undefined
    : undefined;
